function FreeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <g opacity="0.5">
        <path
          d="M11.8423 5.85708C14.8476 4.07818 16.3496 3.18799 17.9996 3.18799C19.6496 3.18799 21.1515 4.0767 24.1569 5.85708L25.173 6.45844C28.1783 8.23882 29.6802 9.12901 30.5052 10.5939C31.3302 12.0603 31.3302 13.8377 31.3302 17.3985V18.6012C31.3302 22.1605 31.3302 23.9408 30.5052 25.4057C29.6802 26.8706 28.1783 27.7608 25.173 29.5397L24.1569 30.1426C21.1515 31.9215 19.6496 32.8116 17.9996 32.8116C16.3496 32.8116 14.8476 31.9229 11.8423 30.1426L10.8262 29.5397C7.8209 27.7623 6.31898 26.8706 5.49396 25.4057C4.66895 23.9394 4.66895 22.1619 4.66895 18.6012V17.3985C4.66895 13.8377 4.66895 12.0588 5.49396 10.5939C6.31898 9.12901 7.8209 8.23882 10.8262 6.45844L11.8423 5.85708Z"
          stroke="url(#paint0_linear_1073_6105)"
          stroke-width="2.22177"
        />
        <path
          d="M11.8423 5.85708C14.8476 4.07818 16.3496 3.18799 17.9996 3.18799C19.6496 3.18799 21.1515 4.0767 24.1569 5.85708L25.173 6.45844C28.1783 8.23882 29.6802 9.12901 30.5052 10.5939C31.3302 12.0603 31.3302 13.8377 31.3302 17.3985V18.6012C31.3302 22.1605 31.3302 23.9408 30.5052 25.4057C29.6802 26.8706 28.1783 27.7608 25.173 29.5397L24.1569 30.1426C21.1515 31.9215 19.6496 32.8116 17.9996 32.8116C16.3496 32.8116 14.8476 31.9229 11.8423 30.1426L10.8262 29.5397C7.8209 27.7623 6.31898 26.8706 5.49396 25.4057C4.66895 23.9394 4.66895 22.1619 4.66895 18.6012V17.3985C4.66895 13.8377 4.66895 12.0588 5.49396 10.5939C6.31898 9.12901 7.8209 8.23882 10.8262 6.45844L11.8423 5.85708Z"
          stroke="black"
          stroke-opacity="0.2"
          stroke-width="2.22177"
        />
      </g>
      <path
        d="M17.9992 22.4437C20.4533 22.4437 22.4428 20.4543 22.4428 18.0002C22.4428 15.5461 20.4533 13.5566 17.9992 13.5566C15.5451 13.5566 13.5557 15.5461 13.5557 18.0002C13.5557 20.4543 15.5451 22.4437 17.9992 22.4437Z"
        stroke="url(#paint1_linear_1073_6105)"
        stroke-width="2.22177"
      />
      <path
        d="M17.9992 22.4437C20.4533 22.4437 22.4428 20.4543 22.4428 18.0002C22.4428 15.5461 20.4533 13.5566 17.9992 13.5566C15.5451 13.5566 13.5557 15.5461 13.5557 18.0002C13.5557 20.4543 15.5451 22.4437 17.9992 22.4437Z"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="2.22177"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1073_6105"
          x1="4.66895"
          y1="-6.3339"
          x2="37.5742"
          y2="-2.01703"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1073_6105"
          x1="13.5557"
          y1="10.7001"
          x2="24.4807"
          y2="12.2926"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default FreeIcon;
